import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import styles from './styles/file-input.module.css';
import sharedStyles from './styles/shared-components.module.css';
import './styles/file-input.css';
import { Button, Upload, Tooltip, Divider } from 'antd';
import { SendOutlined, PaperClipOutlined, ReloadOutlined } from '@ant-design/icons';
import { addAnswer } from '@/store/slices/chatbotFlow';
import PropTypes from 'prop-types';

const FileInput = ({ addAnswer, isChatbotVisible, animTransition }) => {
  const [fileList, setFileList] = useState([]);
  const [base64File, setBase64File] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isFileSelected = fileList.length > 0;

  const handleFileLoad = (file, result) => {
    setFileList([file]);
    setBase64File(result);
    setLoading(false);
  };

  const handleFileError = (message) => {
    setShowError(true);
    setErrorMessage(message);
    setLoading(false);
  };

  const submitInput = useCallback(() => {
    if (!isFileSelected) {
      handleFileError('Please select a file');
      return;
    }
    addAnswer({ name: fileList[0].name, data: base64File });
  }, [isFileSelected, fileList, base64File, addAnswer]);

  const beforeUpload = useCallback((file) => {
    setShowError(false);
    setErrorMessage('');
    setLoading(true);

    const reader = new FileReader();
    reader.onload = e => handleFileLoad(file, e.target.result);
    reader.onerror = () => handleFileError('Error reading file');
    reader.readAsDataURL(file);

    return false;
  }, []);

  const onRemove = useCallback(() => {
    setFileList([]);
  }, []);

  return (
    <div className={sharedStyles.wrapper}>
      <div className={styles.input_container}>
        {isFileSelected ? (
          <div className={styles.file_display}>
            <span className={styles.filename}>{fileList[0].name}</span>
            <Button
              className={styles.delete_button}
              danger
              onClick={onRemove}
              type="link"
              icon={<ReloadOutlined style={{ fontSize: '18px' }} />}
            />
          </div>
        ) : (
          <Upload
            beforeUpload={beforeUpload}
            showUploadList={false}
          >
            <span className={styles.placeholder}>Click here to select a file</span>
          </Upload>
        )}
      </div>
      <div className={styles.buttons}>
        <Tooltip
          placement="topRight"
          align={{ offset: [-5, -5] }}
          title={errorMessage}
          open={showError && isChatbotVisible && animTransition}
        >
          <Button
            className={sharedStyles.send_button}
            loading={loading}
            danger={showError}
            onClick={submitInput}
            type="text"
            icon={
              isFileSelected ? (
                <SendOutlined style={{ fontSize: '24px' }} />
              ) : (
                <Upload
                  beforeUpload={beforeUpload}
                  showUploadList={false}
                >
                  <PaperClipOutlined style={{ fontSize: '24px' }} />
                </Upload>
              )
            }
          />
        </Tooltip>
      </div>
    </div>
  );
};

FileInput.propTypes = {
  addAnswer: PropTypes.func.isRequired,
  isChatbotVisible: PropTypes.bool.isRequired,
  animTransition: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isChatbotVisible: state.chatbotVisibility.isVisible,
  animTransition: state.chatbotVisibility.animTransition,
});

const mapDispatchToProps = { addAnswer };

export default connect(mapStateToProps, mapDispatchToProps)(FileInput);